import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  qryMessagePageByApp: '/msg/sysMessageInfo/qryMessagePageByApp'
};

export const useQryMessagePageByApp = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.qryMessagePageByApp,
      method: 'get',
      data: q || {}
    }, { token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getList: runAsync
  };
};
